<zxing-scanner
  (scanSuccess)="scanSuccess($event)"
  [formats]="[BarcodeFormat.QR_CODE]"
  (camerasFound)="askForCameraPermission()"
  (camerasNotFound)="camerasNotFound()"
  [autostart]="true"
  [device]="selectedDevice"
></zxing-scanner>
